<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__lane' : 'collapsible collapsed collapsible__lane'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getLaneImage(laneId)" fluid style="height:30px"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand" v-html="LaneClosureRequest.getLaneTextMultiLine(laneId)"></div>
								<div class="collapsible-heading__status" @click="onToggleExpand"><div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div></div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseLaneListing" @click="onToggleExpand">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
						<b-collapse id="collapseLaneListing" :visible="expand" class="collapsible-entries">
							<div v-for="(p, uindex) in preset[0].lane" v-if="p.laneId.value == laneId" class="collapsible-unique">
								<div class="collapsible-entry__details">
									<div v-html="getPeakReasonText(uindex)"></div>
								</div>
								<div :class="flexClasses(b2index)" v-if="isEntry(b2index, uindex)" v-for=" (b, b2index) in value" :key="'vbll2index'+b2index+'-'+renderCounter">
									<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index)"></div>
									<div class="flex-grow-1 ">
										<div class="d-flex collapsible-entry__title-wrapper">
											<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
											<div class="collapsible-entry__map-button">
												<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
					<!-- End of desktop -->

					<div v-if="$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__lane' : 'collapsible collapsed collapsible__lane'" style="position: relative">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getLaneImage(laneId)" fluid style="height:30px"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									{{LaneClosureRequest.getLaneText(laneId)}}
									<!-- <div class="flex-table"></div> -->
									<div v-if="!hasBlocks">NO BLOCKS</div>
								</div>
								<div @click="onToggleExpand" class="collapsible-heading__effect">
									<div class="flex-table" v-html="getInEffectTitle()"></div>
								</div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell pr-2' : 'flex-table-cell collapsed pr-2'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseLaneListing" @click="onToggleExpand">
											<span>
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="$store.state.isMobile && expand">
						<transition name="slide-fade" tag="div">
							<div class="d-block section-slide-panel review-step" v-if="showPanel">
								<div class="top-controls">
									<button type="button" @click="onApply">
										<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
									</button>
								</div>
								<div class="panels-body panels-body-padded">
									<div class="panels-nav-title" v-html="getNavTitle"></div>
									<div class="panels-primary-title" v-html="getModalTitle"></div>
									<div class="d-flex" v-if="false"><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-close.svg" alt="" /><span class="status-circle__label">Closed</span></div><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-open.svg" alt="" /><span class="status-circle__label">Open</span></div><div class="lcr-summary__status-legend"><span class="status-circle r-not-reported"></span><span class="status-circle__label"> Not Reported</span></div></div>
									<div v-for="(p, uindex) in preset[0].lane" v-if="p.laneId.value == laneId" class="collapsible-unique">
										<div class="panels-body-content">
											<div class="collapsible-entry__details">
												<div v-html="getPeakReasonText(uindex)"></div>
											</div>
											<div :class="flexClasses(b2index)" v-if="isEntry(b2index, uindex)" v-for=" (b, b2index) in value" :key="'vbll2index'+b2index+'-'+renderCounter">
												<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index)"></div>
												<div class="flex-grow-1 ">
													<div class="d-flex collapsible-entry__title-wrapper">
														<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
														<div class="collapsible-entry__map-button">
															<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div v-if="false" class="panels-apply">
									<div class="d-flex">
										<div class="panels-apply__back"><b-button @click="onApply" variant="text" class="btn-cancel" type="button">Back</b-button></div>
									</div>
								</div>

							</div>
						</transition>
					</div>


				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>
<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'

import Vue from 'vue'

export default {
	name: 'ViewLaneClosureRequestBlockLaneListing',
	props: ['value', 'preset', 'laneId', 'expand', 'uniqueLanes', 'canReport'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			backup: {},
			renderCounter: 0,
			showPanel: false,
			hasBlocks: true,
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
	watch: {

	},
	computed: {
		getNavTitle() {
			return "Closing Traffic Lanes";
		},
		getModalTitle() {
			return 	this.LaneClosureRequest.getLaneTextMultiLine(this.laneId);
		},
		entries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.lane) {
					for (x = 0; x < entry.lane.length; x++) {
						if (entry.lane[x].laneId.value == that.laneId) {
							return true;
						}
					}
				}
				return false;
			})
		},
		isAssigned: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.lane) {
					for (x = 0; x < entry.lane.length; x++) {
						if (entry.lane[x].laneId.value == that.laneId) {
							return true;
						}
					}
				}
				return false;
			})
		},

		nonEntries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.lane) {
					for (x = 0; x < entry.lane.length; x++) {
						if (entry.lane[x].laneId.value == that.laneId) {
							return false;
						}
					}
				}
				if (LaneClosureRequest.hasTrafficLaneInDirection(that.laneId, entry.directionId)) {
					return true;
				} else {
					return false;
				}
			})
		},

		getTurningRestrictionTitle: function() {
			let title = "Restriction";
			if (this.value && this.isEditing) {
				title = "Restriction(s) from " + this.value[this.editingIndex].streetName.value + "";
			}
			return title;
		}
	},
	methods: {
		getLanePeakReasonText(index) {
			let html = "";
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.value[index].lane[x].laneId.value == this.laneId) {

							html = LaneClosureRequest.getLanePeakReasonText(this.value[index].lane[x].peakId.value);
							if (this.value[index].lane[x].peakId.value == 6 || this.value[index].lane[x].peakId.value == 13 || this.value[index].lane[x].peakId.value == 19) {
								html += "<br/>" + this.value[index].lane[x].peakReason.value;
							}
						}
					}
				}
			}
			return html;
		},

		getPeakReasonText(index) {
			let html = "";
			if (this.value) {
				if (this.preset[0].lane[index]) {
					html = LaneClosureRequest.getLanePeakReasonText(this.preset[0].lane[index].peakId.value);
					if (this.preset[0].lane[index].peakId.value == 6 || this.preset[0].lane[index].peakId.value == 13 || this.preset[0].lane[index].peakId.value == 19) {
						html += "<br/>" + this.preset[0].lane[index].peakReason.value;
					}
				}
			}
			return html;
		},



		getLanePeakReasonValue(index) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.value[index].lane[x].laneId.value == this.laneId) {

						}
					}
				}
			}
			return null;
		},
		getInEffectTitle() {
			var texts = [];
			var checkBlocks = false;
			if (this.value) {
				for (var xx = 0; xx < this.value.length; xx++) {
					for (var x = 0; x < this.value[xx].lane.length; x++) {
						if (this.value[xx].lane[x].laneId.value == this.laneId) {
							if (texts["" + this.value[xx].lane[x].inEffect.value]) {} else {
								texts["" + this.value[xx].lane[x].inEffect.value] = 0;
							}
							texts["" + this.value[xx].lane[x].inEffect.value]++;
							checkBlocks = true;
						}
					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				html += "<div class='status-circle lc-closed'>" + texts["1"] + "</div>";
			}
			if (texts["0"] > 0) {
				// open
				html += "<div class='status-circle lc-open'>" + texts["0"] + "</div>";
			}
			if (texts["null"] > 0) {
				// not reported
				// html += "<div class='status-circle lc-not-reported'>" + texts["null"] + "</div>";
				html += "<div class='status-circle lc-closed'>" + texts["null"] + "</div>";
			}
			if (!checkBlocks) {
				// html = "<div>NO BLOCKS</div>";
			}
			this.hasBlocks = checkBlocks;
			return html;
		},
		getInEffectText(index) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.value[index].lane[x].laneId.value == this.laneId) {
							return LaneClosureRequest.getLaneInEffectText(this.value[index].lane[x].inEffect.value);
						}
					}
				}
			}
			return null;
		},

		getInEffectIcon(index) {
			var texts = [];
			if (this.value) {
				for (var x = 0; x < this.value[index].lane.length; x++) {
					if (this.value[index].lane[x].laneId.value == this.laneId) {
						if (texts["" + this.value[index].lane[x].inEffect.value]) {} else {
							texts["" + this.value[index].lane[x].inEffect.value] = 0;
						}
						texts["" + this.value[index].lane[x].inEffect.value]++;
					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				// html += "<div class='status-circle-solid lc-closed'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-close.svg" alt="" />';

			}
			if (texts["0"] > 0) {
				// open
				// html += "<div class='status-circle-solid lc-open'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-open.svg" alt="" />';
			}
			if (texts["null"] > 0) {
				// not reported
				// html += "<div class='status-circle-solid lc-not-reported'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-close.svg" alt="" />';
			}



			return html;
		},


		classes: function(index, uindex) {
			if (this.isEntry(index, uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		flexClasses: function(index) {
			// if (this.isEntry(index)) {
			// 	return "d-flex collapsible-entry";
			// } else {
			// }
			return "d-flex collapsible-entry";
		},
		hasEntries: function(uniqueIndex) {
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.uniqueLanes[uniqueIndex]) {
							if (
								this.value[index].lanesClosedSameTime.value == this.uniqueLanes[uniqueIndex].lanesClosedSameTime &&
								this.value[index].trafficSignalsAltered.value == this.uniqueLanes[uniqueIndex].trafficSignalsAltered &&
								this.value[index].lane[x].laneId.value == this.uniqueLanes[uniqueIndex].laneId &&
								this.value[index].lane[x].laneId.value == this.laneId &&
								this.value[index].lane[x].peakId.value == this.uniqueLanes[uniqueIndex].peakId &&
								this.value[index].lane[x].peakReason.value == this.uniqueLanes[uniqueIndex].peakReason
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},
		isEntry: function(index, uniqueIndex) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.preset[0].lane[uniqueIndex]) {
							if (
							// this.value[index].lanesClosedSameTime.value == this.preset[0].lane[uniqueIndex].lanesClosedSameTime
							// && this.value[index].trafficSignalsAltered.value == this.preset[0].lane[uniqueIndex].trafficSignalsAltered
							 this.value[index].lane[x].laneId.value == this.preset[0].lane[uniqueIndex].laneId.value
							&& this.value[index].lane[x].peakId.value == this.preset[0].lane[uniqueIndex].peakId.value
							// && this.value[index].lane[x].peakReason.value == this.preset[0].lane[uniqueIndex].peakReason.value
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},
		switchId(prefix, block, id) {
			return prefix + "-" + block + "-" + id;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		editBlock: function(id) {
			Vue.prototype.$bus.$emit("block:edit-lanes", id);
		},
		showOnMap: function(id) {
			Vue.prototype.$bus.$emit("block:show-on-map", {id, type: "lane", laneId: this.laneId});
		},
		addBlock: function(laneId, blockId) {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("block:list-add-lane", { laneId: laneId, blockId: blockId });
		},
		toggleRemoveBlock: function(index) {
			this.renderCounter++;
			if (this.isEntry(index)) {
				Vue.prototype.$bus.$emit("block:list-remove-lane", { laneId: this.laneId, blockId: this.value[index].blockId });
			} else {
				Vue.prototype.$bus.$emit("block:list-add-lane", { laneId: this.laneId, blockId: this.value[index].blockId });
			}
		},
		onReview: function() {
			Vue.prototype.$bus.$emit("block:list-expand-lane", { laneId: this.laneId, expand: true });
		},
		onApply: function() {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-lane", { laneId: that.laneId, expand: !that.expand });
			}, 250);
		},
		onReport() {
			Vue.prototype.$bus.$emit("block:report-lane-closure", null);
		},
		onSwipeRight() {
			if (this.showPanel) {
				this.showPanel = false;
			}
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-lane", { laneId: that.laneId, expand: false });
			}, 250);
		},
		onToggleExpand: function() {
			Vue.prototype.$bus.$emit("block:list-expand-lane", { laneId: this.laneId, expand: !this.expand });
		},
	}
}
</script>